import React from 'react'

interface SubscriptionCardProps {
  className?: string;
  onClick?: () => void;
  title: string;
  description: string;
}

const SubscriptionCard = ({description,title,className,onClick}: SubscriptionCardProps) => {
  return (
      <div
      onClick={onClick}
      className={`w-full min-h-[120px] p-5 bg-[var(--input-bg-color)] flex flex-col gap-4 items-start justify-center rounded-xl ${className ?? ""
        }`}
    >
      <p className="font font-bold  text-[1rem] whitespace-nowrap mt-[5px] text-[var(--primary-text-color)]">{title}</p>
      <p className="font text-[0.9rem]  mt-[5px] text-[var(--primary-text-color)]">{description}</p>
    </div>
  )
}

export default SubscriptionCard
